import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  button: {
    marginLeft: -theme.spacing(1)
  }
}));

export { useStyles };
